import { createSelector } from "reselect"
import { get, capitalize } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"

export const getSelectedTradeType = (state) => get(state, "modules.rebalanceTrades.tradeType")
export const getOpenTradeId = (state) => get(state, "modules.rebalanceTrades.openTradeId")
const getTrades = (state, props) => get(props, "trades")
const getDate = (state, props) => props.selectedDate

export const getFileName = createSelector(
  [getPortfolioName, getViewType, getDate],
  (portfolioName, viewType, date) => `${portfolioName} Rebalance Trades ${capitalize(viewType.substr(0, 3))} ${date}`,
)

export const getFilteredTrades = createSelector(
  [getTrades, getSelectedTradeType],
  (trades, selectedTradeType) => trades[selectedTradeType],
)
